export function isSharedUrl() {
  const origin = window.location.origin.toLowerCase();
  const href = window.location.href.toLowerCase();

  return href.startsWith(`${origin}/shared/`);
}
export function isNoteShareDomain() {
  const hostname = window.location.hostname.toLowerCase();

  return hostname.startsWith("share.");
}

export function shareDomainGuard() {
  if (isSharedUrl() && !isNoteShareDomain()) {
    // we dont want shared notes to have access to app domain
    // because we cannot control the content of the shared note
    window.location = `${window.location.protocol}//share.${window.location.host}${window.location.pathname}`;
  } else if (isNoteShareDomain() && !isSharedUrl()) {
    // we dont want users to be tricked into logging into the app using the shared domain.
    const safeHost = window.location.host
      .toLowerCase()
      .replaceAll("share.", "");
    window.location = `${window.location.protocol}//${safeHost}${window.location.pathname}`;
  }
}
export function getShareDomain() {
  return `${window.location.protocol}//share.${window.location.host}`;
}
